<div class="statistics-cap-text">
    <p-message severity="warn" icon="pi pi-exclamation-triangle">
        <span translate>No data showing? Add the Acquia Web Governance script to your website</span>
        <a class="statistics-cap-text__link gel-link"
           href="https://docs.acquia.com/web-governance/how-add-web-governance-script"
           target="_blank"
           rel="noopener noreferrer">
            <span translate>Learn how to add the script</span>
            <mon-svg-icon name="openInNew" />
        </a>
    </p-message>
</div>
